import { render, staticRenderFns } from "./PermissionListComponent.vue?vue&type=template&id=e57d5730&"
import script from "./PermissionListComponent.vue?vue&type=script&lang=js&"
export * from "./PermissionListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports